const containerStyles = {
  marginTop: '40px',
  marginBottom: '40px',
  padding: '0 16px'
};
export default containerStyles;